import React from "react";
import classNames from "classnames/bind";
import styles from "./AboutCompanySEO.module.scss";
import { useConfig } from "../../providers/config";

const cx = classNames.bind(styles);

const about = (aboutCompanyHtml: string | undefined) => {
  if (!aboutCompanyHtml) return;

  return {
    __html: aboutCompanyHtml,
  };
};

const AboutCompanySEO: React.FC = () => {
  const { aboutCompanyHtml } = useConfig();
  return <div className={cx("about", "ion-hide-md-down")} dangerouslySetInnerHTML={about(aboutCompanyHtml)}></div>;
};

export default AboutCompanySEO;
